import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomersService } from '../../../customers/customers.service';
import { Customer } from '../../../shared/models/customer.model';

@Component({
  selector: 'exa-utility-bills-monthly-analysis-pg',
  templateUrl: './utility-bills-monthly-analysis-pg.component.html',
  styleUrls: ['./utility-bills-monthly-analysis-pg.component.scss']
})
export class UtilityBillsMonthlyAnalysisPgComponent implements OnInit {

  customer$: Observable<Customer>;

  constructor(private customerSvc: CustomersService) { }

  ngOnInit() {
    this.customer$ = this.customerSvc.selected$;
  }

}
